import React from "react";
import "./reasons.css";
import appLogo from "../../Media/zzz.png";
import cheap from "../../Media/cheap.svg";
import conv from "../../Media/conv.svg";
import fast from "../../Media/fast.svg";
import effect from "../../Media/effect.svg";

const Reasons = () => {
  return (
    <div className="reasons">
      <h1>Why you should choose DepRelief</h1>

      <div className="reasons_content">
        <div className="reason">
          <img src={conv} alt="reasons-img" />
          <h3>Its Convenient</h3>
          <p>
            Get access to therapy at your own time and at your own pace. You can
            communicate with others as often as need.{" "}
          </p>
        </div>
        <div className="reason">
          <img src={effect} alt="reasons-img" />
          <h3>Its Effective</h3>
          <p>
            The rate of your recovery is definitely going to be quicker and
            higher since you are getting help from people just like you.
          </p>
        </div>
        <div className="reason">
          <img src={fast} alt="reasons-img" />
          <h3>Its Fast</h3>
          <p>
            You can book an appointment with an approved therapist within a
            couple of minutes.{" "}
          </p>
        </div>
        <div className="reason">
          <img src={cheap} alt="reasons-img" />
          <h3>Its Affordable</h3>
          <p>
            Pay a low amount to get therapy from your therapist at anytime. Your
            Relief is more important to us than the money.{" "}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Reasons;
